import React from 'react'
import { Link } from 'react-router-dom'

function Fututocombi() {
    return (
        <div className=' font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/semiverticals" className="block py-1 pl-4 hover:underline mt-6">Semi Verticals -</Link>
           <span className="block py-1 pl-4 mt-6">FUTURO COMBI</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/newfuturo.png" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">FUTURO COMBI</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">Total versatility combines serve-over and self-service.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">FUTURO COMBI is the combo display cabinet for food retail that perfectly combines the qualities of a serve-over with a self-service semi-vertical. The range is available in chilled, dry ambient and heated models, discover the innovative solution that will double your sales!.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Assisted service/ self-service models for</h2>
    <h2 className="text-3xl font-thin opacity-80   text-center ">Meat and charcuterie products</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">

       <p className="text-xl lg:text-2xl opacity-90">upper compartment <span className=' text-blue-500'> -1… +7 °C</span> (3M2)</p>
       <p className="text-xl lg:text-2xl opacity-90"> lower compartment <span className=' text-blue-500'> -1… +5 °C</span> (3M1)</p>

       <p className="text-xl lg:text-2xl opacity-90">Hot foods  <span className=' text-red-600'>+65 °C</span></p>
      
    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
         
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-6">Glicol  |  CO2</p>

         </div>
    
   


         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/futurocombicase.jpg" className="max-w-full h-auto object-contain" />
               </div>
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl md:text-4xl">The 2-in-1 display unit that doubles business opportunities!</p>
    <div className='mt-6 text-xl md:text-2xl font-thin text-gray-500'>High capacity, for simultaneous assisted service and self-service of refrigerated, non-refrigerated and hot food products, Futuro Combi is the retail combo display cabinet that combines multifunctionality and service to make the most of the space available in the store.</div>


</div>
                
             </div>
         </div>
    
    {/* card & description */}
    <div className="flex flex-wrap gap-6 justify-center mt-16">
  {[
    {
      img: "images/futurocombicard.jpg",
      text: "Upper compartment with sliding rear service doors and worktop.",
    },
    {
      img: "images/futurocombicard1.jpg",
      text: "High-brightness LED lighting at all display levels.",
    },
    {
      img: "images/futurocombicard2.jpg",
      text: "Lower compartment with tilting shelf and night curtain.",
    },
   
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>
     </div>
    
  
        </div>
      )
    }


export default Fututocombi